import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import { reducer as achievementsReducer } from './slices/achievements';
import { reducer as bookmarkReducer } from './slices/bookmarks';
import { reducer as coverageReducer } from './slices/coverage';
import { reducer as documentationReducer } from './slices/documentation';
import { reducer as insightsReducer } from './slices/insights';
import { reducer as internalLibrariesReducer } from './slices/internalLibraries';
import { reducer as loadingReducer } from './slices/loading';
import { reducer as releasesReducer } from './slices/newsletter';
import { reducer as personalStatsReducer } from './slices/personal_stats';
import { reducer as projectsReducer } from './slices/projects';
import { reducer as repositoriesReducer } from './slices/repositories';
import { reducer as rolesReducer } from './slices/roles';
import { reducer as scopesReducer } from './slices/scopes';
import { reducer as suggestionsReducer } from './slices/scopesSuggestions';
import { reducer as servicesReducer } from './slices/services';
import { reducer as channelsReducer } from './slices/slack_channels';
import { reducer as snackReducer } from './slices/snack';
import { reducer as softwareReducer } from './slices/softwares';
import { reducer as tagsReducer } from './slices/tags';
import { reducer as tasksSuggestionsReducer } from './slices/tasksSuggestions';
import { reducer as teamsReducer } from './slices/teams';
import { reducer as usersReducer } from './slices/users';

// `reducers` and `extraArgument` are how a platform adds what only it needs:
// the web app passes heimdal-react's session branch and its Heimdal client.
// `services` is merged in, not replaced, so the app's own thunks keep it.
export default function _createStore(services, { reducers, extraArgument } = {}) {
  return createStore(
    combineReducers({
      ...reducers,
      achievements: achievementsReducer,
      projects: projectsReducer,
      roles: rolesReducer,
      users: usersReducer,
      tags: tagsReducer,
      scopes: scopesReducer,
      loading: loadingReducer,
      snack: snackReducer,
      bookmarks: bookmarkReducer,
      teams: teamsReducer,
      releases: releasesReducer,
      slack_channels: channelsReducer,
      softwares: softwareReducer,
      coverage: coverageReducer,
      documentation: documentationReducer,
      personalStats: personalStatsReducer,
      repositories: repositoriesReducer,
      services: servicesReducer,
      scopesSuggestions: suggestionsReducer,
      tasksSuggestions: tasksSuggestionsReducer,
      insights: insightsReducer,
      internalLibraries: internalLibrariesReducer,
    }),
    applyMiddleware(thunk.withExtraArgument({ ...extraArgument, services })),
  );
}
